// import Genders from '@Enums/Genders';    // TODO: import doesnt work
import { enumCodec, mixed, required, t, timestampCodec } from '../../validation/validator';
import { CallResponseSchema, CallResponseSchemaNoData } from '../common/callResponseSchema';

// Base types

export const BybcatConfig = t.type({
    id: t.number,
    name: t.string,
    account_id: t.number,
    storage_bucket: t.string,
    created_at: timestampCodec,
    updated_at: t.union([timestampCodec, t.null]),
    test_code: t.number,
    slice_count: t.number,
    slice_length: t.number,
    min_slice_speed: t.number,
    max_slice_speed: t.number,
    warmup_code: t.number,
    warmup_speed: t.number,
    warmup_neutral_count: t.number,
    warmup_inhibition_count: t.number,
    warmup_pr_count: t.number,
    warmup_wm_count: t.number,
    wm_count: t.number,
    wm_subject_count: t.number,
    wm_max_incorrect_answers: t.number,
    wm_duration: t.number,
    wm_minimum_game_time: t.number,
    pr_count: t.number,
    pr_subject_count: t.number,
    pr_max_incorrect_answers: t.number,
    pr_duration: t.number,
    pr_minimum_game_time: t.number,
    inhibition_count: t.number,
    inhibition_duration: t.number
});

export const BybcatUser = t.intersection([
    t.type({
        id: t.number,
        name: t.string,
        created_at: timestampCodec,
    }),
    t.partial({
        user_id: t.union([t.number, t.null]),
        birth_date: t.union([timestampCodec, t.null]),
        email: t.union([t.string, t.null]),
        play_position_id: t.union([t.number, t.null]),
        gender: t.string,
        updated_at: t.union([timestampCodec, t.null]),
        groups: t.array(t.type({
            id: t.number,
            name: t.string
        }))
    })
]);

export enum BybcatResultStatus {
    SCHEDULED = 'scheduled',
    IN_PROGRESS = 'in_progress',
    COMPLETE = 'complete',
    INCOMPLETE = 'incomplete'
}

export const BybcatResult = t.type({
    id: t.number,
    bybcat_config_id: t.number,
    bybcat_user_id: t.number,
    storage_bucket: t.string,
    results_storage_file_path: t.string,
    results_storage_file_size: t.number,
    status: enumCodec(BybcatResultStatus),
    created_at: timestampCodec,
    updated_at: t.union([timestampCodec, t.null]),
    results_data: t.any
});

export enum Action {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete'
}

export enum BybcatEventAction {
    UPDATE_RESULT = 'update_result',
    START = 'start',
    WARMUP = 'warmup',
    SET_SETTINGS = 'set_settings'
}

// Request schemas
export const UpdateUserRequest = t.intersection([
    t.type({
        action: t.union([t.literal('create'), t.literal('update'), t.literal('delete')]),
        account_id: t.number,
    }),
    t.partial({
        bybcat_user_id: t.union([t.number, t.null]),
        name: t.string,
        birth_date: timestampCodec,
        email: t.string,
        play_position_id: t.number,
        gender: t.string
    })
]);

export const GetUsersRequest = t.intersection([
    t.type({
        account_id: t.number,
    }),
    t.partial({
        bybcat_config_id: t.number,
        bybcat_user_ids: t.array(t.number)
    })
]);

export const UpdateConfigRequest = t.intersection([
    t.type({
        action: t.union([t.literal('create'), t.literal('update'), t.literal('delete')]),
    }),
    t.partial({
        bybcat_config_id: t.number,
        name: t.string,
        account_id: t.number,
        test_code: t.number,
        slice_count: t.number,
        slice_length: t.number,
        min_slice_speed: t.number,
        max_slice_speed: t.number,
        warmup_code: t.number,
        warmup_speed: t.number,
        warmup_neutral_scenarios: t.number,
        warmup_inhibition_tests: t.number,
        warmup_pr_tests: t.number,
        warmup_wm_tests: t.number,
        wm_count: t.number,
        wm_subject_count: t.number,
        wm_max_incorrect_answers: t.number,
        wm_duration: t.number,
        wm_minimum_game_time: t.number,
        pr_count: t.number,
        pr_subject_count: t.number,
        pr_max_incorrect_answers: t.number,
        pr_duration: t.number,
        pr_minimum_game_time: t.number,
        inhibition_test_count: t.number,
        inhibition_test_duration: t.number
    })
]);

export const GetConfigsRequest = t.partial({
    account_id: t.number,
    bybcat_config_ids:t.array(t.number)
});

export const UpdateResultsRequest = t.intersection([
    t.type({
        action: t.union([t.literal('create'), t.literal('update'), t.literal('delete')]),
        bybcat_config_id: t.number,
    }),
    t.partial({
        bybcat_result_id: t.number,
        bybcat_user_id: t.number,
        group_ids: t.array(t.number),
        status: t.union([t.literal('scheduled'), t.literal('in_progress'), t.literal('complete'), t.literal('incomplete')]),
        results_data: t.any
    })
]);

export const GetResultsRequest = t.intersection([
    t.type({
        account_id: t.number,
    }),
    t.partial({
        result_ids: t.union([t.array(t.number), t.undefined]),
        bybcat_config_ids: t.union([t.array(t.number), t.undefined]),
        bybcat_user_ids: t.union([t.array(t.number), t.undefined]),
        status: t.union([t.literal('scheduled'), t.literal('in_progress'), t.literal('complete'), t.literal('incomplete')]),
        limit: t.number,
        offset: t.number,
    })
]);

// Group type definition
export const BybcatGroup = t.type({
    id: t.number,
    name: t.string,
    account_id: t.number,
    description: t.union([t.string, t.null]),
    created_at: timestampCodec,
    updated_at: t.union([timestampCodec, t.null]),
    users: t.union([t.array(BybcatUser), t.undefined])
});

// Request schemas for groups
export const UpdateGroupRequest = t.intersection([
    t.type({
        action: t.union([t.literal('create'), t.literal('update'), t.literal('delete')]),
        account_id: t.number,
    }),
    t.partial({
        bybcat_group_id: t.union([t.number, t.null]),
        name: t.union([t.string, t.null]),
        description: t.union([t.string, t.null]),
        add_user_ids: t.union([t.array(t.number), t.null]),
        remove_user_ids: t.union([t.array(t.number), t.null])
    })
]);

export const GetGroupsRequest = t.intersection([
    t.type({
        account_id: t.number,
    }),
    t.partial({
        bybcat_group_ids: t.array(t.number)
    })
]);

// For batch creating users
export const BatchUserInput = t.intersection([
    t.type({
        name: t.string,
    }),
    t.partial({
        birth_date: t.union([timestampCodec, t.null]),
        email: t.union([t.string, t.null]),
        play_position_id: t.number,
        gender: enumCodec({ MALE: 'MALE', FEMALE: 'FEMALE', NA: 'NA' }),
        group_names: t.array(t.string)
    })
]);

export const BatchCreateUsersRequest = t.type({
    account_id: t.number,
    users: t.array(BatchUserInput)
});

// Type aliases
export type BybcatConfigType = t.TypeOf<typeof BybcatConfig>;
export type BybcatUserType = t.TypeOf<typeof BybcatUser>;
export type BybcatResultType = t.TypeOf<typeof BybcatResult>; 
export type UpdateUserRequestType = t.TypeOf<typeof UpdateUserRequest>;
export type GetUsersRequestType = t.TypeOf<typeof GetUsersRequest>;
export type UpdateConfigRequestType = t.TypeOf<typeof UpdateConfigRequest>;
export type GetConfigsRequestType = t.TypeOf<typeof GetConfigsRequest>;
export type UpdateResultsRequestType = t.TypeOf<typeof UpdateResultsRequest>;
export type GetResultsRequestType = t.TypeOf<typeof GetResultsRequest>;
export type BybcatGroupType = t.TypeOf<typeof BybcatGroup>;
export type UpdateGroupRequestType = t.TypeOf<typeof UpdateGroupRequest>;
export type GetGroupsRequestType = t.TypeOf<typeof GetGroupsRequest>;
export type BatchUserInputType = t.TypeOf<typeof BatchUserInput>;
export type BatchCreateUsersRequestType = t.TypeOf<typeof BatchCreateUsersRequest>;

export const BybcatApis = {
    Bybcat: {
        UpdateUser: {
            Name: 'bybcat-updateUser',
            Request: UpdateUserRequest,
            Response: CallResponseSchema
        },
        GetUsers: {
            Name: 'bybcat-getUsers',
            Request: GetUsersRequest,
            Response: mixed([required({ data: t.array(BybcatUser) }), CallResponseSchemaNoData])
        },
        UpdateConfig: {
            Name: 'bybcat-updateConfig',
            Request: UpdateConfigRequest,
            Response: CallResponseSchema
        },
        GetConfigs: {
            Name: 'bybcat-getConfigs',
            Request: GetConfigsRequest,
            Response: mixed([required({ data: t.array(BybcatConfig) }), CallResponseSchemaNoData])
        },
        UpdateResults: {
            Name: 'bybcat-updateResults',
            Request: UpdateResultsRequest,
            Response: CallResponseSchema
        },
        GetResults: {
            Name: 'bybcat-getResults',
            Request: GetResultsRequest,
            Response: mixed([required({ data: t.array(BybcatResult) }), CallResponseSchemaNoData])
        },
        UpdateGroup: {
            Name: 'bybcat-updateGroup',
            Request: UpdateGroupRequest,
            Response: CallResponseSchema
        },
        GetGroups: {
            Name: 'bybcat-getGroups',
            Request: GetGroupsRequest,
            Response: mixed([required({ data: t.array(BybcatGroup) }), CallResponseSchemaNoData])
        },
        BatchCreateUsers: {
            Name: 'bybcat-batchCreateUsers',
            Request: BatchCreateUsersRequest,
            Response: CallResponseSchema
        }
    }
}
